import axios from 'axios';

const baseApiUrl = 'api/admin/overview';

export default class DashboardService {
    public retrieve(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axios
                .get(baseApiUrl)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
